module.exports = __webpack_public_path__ + "img/grade19.38ca2d0f.png";